import React, { Fragment, useEffect, useState } from "react";
import Swal from "sweetalert2";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  crmtourviewdetail,
  teamdeletecityreg,
  teamlistcityreg,
  teamselectedplayerlistcityreg,
} from "../../../../services/cityregionaladmin";
import { toast } from "react-toastify";
import {
  teamdelete,
  teamplayerlist,
  tourteamlist,
  tourteamplayerlist,
  tourviewdetail,
} from "../../../../services/superadmin";
import {
  Refteamlist,
  Refteamplayerlist,
  Reftourdetail,
} from "../../../../services/referee";
import exportUrl from "../../../../exportUtl";
import moment from "moment";
import { scheadtourviewdetail, schooltourteamlist, schooltourteamplayerlist } from "../../../../services/schoolhead";

export const TeamWithPlayerList = () => {
  const { id } = useParams();
  const [filterProduct, setFilterProduct] = useState([]);
  const [tname, setTName] = useState("");

  useEffect(() => {
    listall();
    if (localStorage.getItem("Role") === "1") {
      tourviewdetail(id).then((response) => {
        if (response.status === true && response.data.tournament !== null) {
          setTName(response.data.tournament.meet_name);
        }
      });
    } else if (localStorage.getItem("Role") === "3") {
      crmtourviewdetail(id).then((response) => {
        if (response.status === true && response.data.tournament !== null) {
          setTName(response.data.tournament.meet_name);
        }
      });
    }else if (localStorage.getItem("Role") === "4") {
      scheadtourviewdetail(id).then((response) => {
        if (response.status === true && response.data.tournament !== null) {
          setTName(response.data.tournament.meet_name);
        }
      });
    } else if (localStorage.getItem("Role") === "5") {
      Reftourdetail(id).then((response) => {
        if (response.status === true && response.data.tournament !== null) {
          setTName(response.data.tournament.meet_name);
        }
      });
    }
  }, []);

  function listall() {
    setFilterProduct([]);
    if (localStorage.getItem("Role") === "1") {
      tourteamlist(id).then((res) => {
        if (res.status === true) {
          let arr = [];
          if (res.data.length !== 0) {
            for (let i = 0; i < res.data.length; i++) {
              arr.push({
                id: res.data[i].id,
                team_name: res.data[i].team_name,
                player: [],
              });
            }
          }

          if (arr.length !== 0) {
            for (let i = 0; i < arr.length; i++) {
              tourteamplayerlist(id, arr[i].id).then((response) => {
                if (response.status === true) {
                  for (let j = 0; j < response.data.length; j++) {
                    arr[i].player.push(response.data[j]);
                    setFilterProduct([...arr]);
                  }
                }
              });
            }
            setFilterProduct([...arr]);
          }
        }
      });
    } else if (localStorage.getItem("Role") === "3") {
      teamlistcityreg(id).then((res) => {
        if (res.status === true) {
          let arr = [];
          if (res.data.length !== 0) {
            for (let i = 0; i < res.data.length; i++) {
              arr.push({
                id: res.data[i].id,
                team_name: res.data[i].team_name,
                player: [],
              });
              teamselectedplayerlistcityreg(id, res.data[i].id).then(
                (response) => {
                  if (response.status === true) {
                    for (let j = 0; j < response.data.length; j++) {
                      arr[i].player.push(response.data[j]);
                      setFilterProduct([...arr]);
                    }
                  }
                }
              );
            }
            setFilterProduct(arr);
          }
        }
      });
    }else if (localStorage.getItem("Role") === "4") {
      schooltourteamlist(id).then((res) => {
        if (res.status === true) {
          let arr = [];
          if (res.data.length !== 0) {
            for (let i = 0; i < res.data.length; i++) {
              arr.push({
                id: res.data[i].id,
                team_name: res.data[i].team_name,
                player: [],
              });
              schooltourteamplayerlist(id, res.data[i].id).then(
                (response) => {
                  if (response.status === true) {
                    for (let j = 0; j < response.data.length; j++) {
                      arr[i].player.push(response.data[j]);
                      setFilterProduct([...arr]);
                    }
                  }
                }
              );
            }
            setFilterProduct(arr);
          }
        }
      });
    } else if (localStorage.getItem("Role") === "5") {
      Refteamlist(id).then((res) => {
        if (res.status === true) {
          let arr = [];
          if (res.data.length !== 0) {
            for (let i = 0; i < res.data.length; i++) {
              arr.push({
                id: res.data[i].id,
                team_name: res.data[i].team_name,
                player: [],
              });
              Refteamplayerlist(id, res.data[i].id).then((response) => {
                if (response.status === true) {
                  for (let j = 0; j < response.data.length; j++) {
                    arr[i].player.push(response.data[j]);
                    setFilterProduct([...arr]);
                  }
                }
              });
            }
            setFilterProduct(arr);
          }
        }
      });
    }
  }

  function backlist() {
    if (localStorage.getItem("Role") === "1") {
      navigate("/superadmin/teamlist/" + id);
    } else if (localStorage.getItem("Role") === "3") {
      navigate("/cityregional/teamlist/" + id);
    } else if (localStorage.getItem("Role") === "4") {
      navigate("/schoolhead/teamlist/" + id);
    } else if (localStorage.getItem("Role") === "5") {
      navigate("/referee/teamlist/" + id);
    }
  }

  const navigate = useNavigate();
  return (
    <Fragment>
      <div className="side-app">
        <div className="page-header">
          <div className="breadcrumb">
            <h4 className="mb-0">Tournament</h4>
          </div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a>Tournament</a>
            </li>
            <li className="breadcrumb-item">
              <a>Tournament Lists</a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Tournament Team Player Lists
            </li>
          </ol>
        </div>

        <div className="row">
          <div className="col-12">
            <form className="card mt-0">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-10">
                    <h3>{tname}</h3>
                  </div>
                  <div className="col-md-2">
                    <div className="text-right">
                      <a className="btn btn-gray" onClick={backlist}>
                        <i className="fe fe-corner-up-left"></i> Back
                      </a>
                    </div>
                  </div>
                </div>

                <div className="row teamslist mt-4">
                  {filterProduct.length === 0 && (
                    <div className="col-md-4">
                      <div className="card ">
                        <div className="card-header">
                          <h3 className="card-title">No Team Found</h3>
                        </div>
                      </div>
                    </div>
                  )}
                  {filterProduct.map((data, i) => {
                    return (
                      <div className="col-md-12" key={i}>
                        <div className="card ">
                          <div className="card-header">
                            <h3 className="card-title">{data.team_name}</h3>
                          </div>
                          <div className="card-body alignMe">
                            {data.player.length === 0 && (
                              <h4>No Player Added</h4>
                            )}

                            {data.player.map((item, j) => {
                              return (
                                <div key={j}>
                                  <h4 className="h4 mb-0 mt-3">
                                    <b>Player</b> <span>{item.first_name}</span>
                                  </h4>
                                  <h4 className="h4 mb-0 mt-3">
                                    <b>Username (UID)</b>{" "}
                                    <span>{item.username}</span>
                                  </h4>
                                  <h4 className="h4 mb-0 mt-3">
                                    <b>Class</b> <span>{item.class_name}</span>
                                  </h4>
                                  <h4 className="h4 mb-0 mt-3">
                                    <b>Section</b> <span>{item.section}</span>
                                  </h4>
                                  <h4 className="h4 mb-0 mt-3">
                                    <b>Gender</b> <span>{item.gender}</span>
                                  </h4>
                                  {item.date_of_birth !== null && (
                                    <h4 className="h4 mb-0 mt-3">
                                      <b>DOB</b>{" "}
                                      <span>
                                        {moment(data.date_of_birth).format(
                                          "DD-MM-YYYY"
                                        )}
                                      </span>
                                    </h4>
                                  )}
                                  {item.date_of_birth === null && (
                                    <h4 className="h4 mb-0 mt-3">
                                      <b>DOB</b>{" "}
                                      <span>{data.date_of_birth}</span>
                                    </h4>
                                  )}
                                  <h4 className="h4 mb-0 mt-3">
                                    <b>School</b>{" "}
                                    <span>{item.school_name}</span>
                                  </h4>
                                  <hr />
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
